import React, { useState } from "react";
import OnboardingList from "./components/OnboardingList";
import { Typography, Tooltip, Button, Drawer, Grid } from "antd";
import { ArrowLeftOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
const { Title } = Typography;

const Onboarding = () => {
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const navigate = useNavigate();
  const [helpOpen, setHelpOpen] = useState(false);
  return (
    <>
     <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "20px",
          justifyContent: "space-between"
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <Button
            type="text"
            icon={<ArrowLeftOutlined style={{ fontSize: 18 }} />}
            onClick={() => navigate(-1)}
            data-testid="onboarding-back-button"
          />
          <Title level={2} style={{ margin: 0 }}>
            Onboarding
          </Title>
        </div>

        <Tooltip title="Help">
          <Button
            type="text"
            icon={<QuestionCircleOutlined style={{ fontSize: 18 }} />}
            onClick={() => setHelpOpen(true)}
            style={{ marginLeft: "8px", alignItems: "right" }}
          />
        </Tooltip>
      </div>
      <OnboardingList />
      <Drawer
        title="Employee Onboarding Help"
        open={helpOpen}
        onClose={() => setHelpOpen(false)}
        width={430}
        styles={{
          wrapper: {
            paddingTop: !screens.md ? "80px" : undefined
          }
        }}
      >
        <div style={{ lineHeight: 1.8 }}>
          <h2
            style={{
              fontSize: "18px",
              fontWeight: 600,
              marginBottom: "12px",
            }}
          >
            Employee Onboarding Management
          </h2>

          <p style={{ color: "#555", marginBottom: "16px" }}>
            The Employee Onboarding module is used to manage employee onboarding
            records within the ERP HR & Payroll system. It helps track applicant
            details, onboarding progress, department assignments, and employee conversion workflows.
          </p>

          <div
            style={{
              background: "#f5f5f5",
              padding: "14px",
              borderRadius: "8px",
              marginBottom: "16px",
            }}
          >
            <strong>Available Actions</strong>

            <ol style={{ paddingLeft: "20px", marginTop: "10px" }}>
              <li>View onboarding records and applicant details</li>
              <li>Search onboarding entries using filters</li>
              <li>Customize visible table columns</li>
              <li>Create new onboarding records</li>
              <li>Edit onboarding details before employee conversion</li>
              <li>Convert onboarding records into employee profiles</li>
              <li>Track onboarding statuses and progress</li>
              <li>Monitor department and designation assignments</li>
            </ol>
          </div>

          <div
            style={{
              background: "#fafafa",
              border: "1px solid #eee",
              padding: "14px",
              borderRadius: "8px",
            }}
          >
            <strong>Important Notes</strong>

            <ul
              style={{
                paddingLeft: "18px",
                marginTop: "10px",
                color: "#666",
              }}
            >
              <li>Converted onboarding records cannot be edited.</li>
              <li>Converted records are linked to employee management.</li>
              <li>Status indicators help track onboarding progress.</li>
              <li>Access permissions control editing functionality.</li>
            </ul>
          </div>
        </div>
      </Drawer>
    </>
  );
};

export default Onboarding;